import { ACTION_TYPES } from '../utils/Constants';

const PushNotificationReducer = (
    state = {
        pushNotification: {},
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.PHYSICIAN.PHYSICIAN_ISONLINE:
            state = {
                ...state,
                pushNotification: action.payload,
            };
            break;
        case ACTION_TYPES.CLEAR_NOTIFICATION:
            state = {
                ...state,
                pushNotification: Object,
            };
            break;
        default:
            break;
    }
    return state;
};
export default PushNotificationReducer;
